import { render } from "./MyAccount.vue?vue&type=template&id=bf89a43e"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
script.render = render

export default script